import { useTranslation } from '@jq4race/i18n';
import { Button } from '@jq4race/ui';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { AuthShell } from '../modules/auth/ui/components/AuthShell';

export const Route = createFileRoute('/invitation')({
  validateSearch: (search: Record<string, unknown>) => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: InvitationRedirectPage,
});

function InvitationRedirectPage() {
  const { t } = useTranslation('auth');
  const { token } = Route.useSearch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    void navigate({ to: '/activate/$token', params: { token }, replace: true });
  }, [navigate, token]);

  if (!token) {
    return (
      <AuthShell
        title={t('invitation.invalidTitle')}
        eyebrow={t('invitation.eyebrow')}
        description={t('invitation.invalidDescription')}
      >
        <Button className="w-full" onClick={() => navigate({ to: '/login' })}>
          {t('invitation.invalidAction')}
        </Button>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      title={t('invitation.redirectingTitle')}
      eyebrow={t('invitation.eyebrow')}
      description={t('invitation.redirectingDescription')}
    >
      <p className="text-[14px] text-jq-graphite">{t('invitation.redirectingBody')}</p>
    </AuthShell>
  );
}
